export default __webpack_public_path__ + "static/media/website-link.a286374b.png";